import React from "react";

export function DriverCompleteJobModal({ open, onClose, actualEndTime, releaseTime }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/40 p-4 sm:items-center" data-testid="driver-complete-modal">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-700">Job completed</p>
        <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-slate-900">Done</h2>
        <div className="mt-4 space-y-2 text-sm text-slate-600">
          <p>Actual finish time: <span className="font-semibold text-slate-900">{actualEndTime ? new Date(actualEndTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—"}</span></p>
          <p>Vehicle available again at <span className="font-semibold text-slate-900">{releaseTime ? new Date(releaseTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—"}</span></p>
        </div>
        <button type="button" onClick={onClose} data-testid="driver-complete-modal-close" className="mt-5 w-full rounded-2xl bg-slate-900 px-5 py-4 text-sm font-semibold text-white">
          Done
        </button>
      </div>
    </div>
  );
}